/* eslint-disable @typescript-eslint/no-unused-vars */

import { Modal, Select, Spin } from "antd";
import Styles from "../css/payWithQuickbucks.module.scss";
import { formatAmount } from "utils/currency";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import Cancel from "../../../../assets/cancel.svg";
import Back from "../../../../assets/back-icon.svg";
import { toast } from "react-toastify";
import { useAppDispatch } from "customHooks/useAppDispatch";
import { useAppSelector } from "customHooks/useAppSelector";
import LoadingCard from "components/shared/LoadingCard/LoadingCard";
import { LoadingOutlined } from "@ant-design/icons";
import { Field, Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import InputField from "components/shared/InputField/InputField";
import HelperText from "components/shared/HelperText/HelperText";
import Button from "components/shared/Button/Button";
import SelectField from "components/shared/SelectField/SelectField";
import { getUserPaymentDetail } from "store/reducers/pay-with-quickbucks-slice";

const PayWithQuickbuckDetailsModal = (props: any) => {
  const { loadingApi, repaymentResponseData, isInspection, equityValue, loanAmount } =
    props;
  const { Option } = Select;
  const location = useLocation();
  const [status] = useState("Pending");
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [amount, setAmount] = useState(0);
  const [hideEquity, setHideEquity] = useState(true);
  const { paymentCode } = useParams<{ paymentCode?: string }>();

  const [inspectionStatus] = useState("Pending");
  const [Tenor] = useState([
    // { id: 1, name: "1 month", code: "1" },
    { id: 2, name: "3 month", code: "3" },
    { id: 3, name: "6 month", code: "6" },
    { id: 3, name: `9 month`, code: "9" },
    { id: 3, name: `12 month`, code: "12" },
  ]);

  const dispatch = useAppDispatch();

  const paymentData = useAppSelector(
    (state) => state?.payLaterVendor?.paymentInfo
  );

  // const loanAmount =
  // Number(paymentData?.Amount) -
  // (Number(equityValue));

  // console.log('loanAmount',equityValue)

  const miniEquity = paymentData?.MinimumEquity;
  const MinimumEquity = Math.ceil(miniEquity * 100) / 100;

  const [isChecked, setIsChecked] = useState(false);
  const [isNew] = useState(!paymentData?.Meta?.Items?.IsNew);

  const VehicleSchema = Yup.object().shape({
    // EquityContribution: Yup.string().required(
    //   "Equity Contribution is Required"
    // ),
    EquityContribution: Yup.string().when([], {
      is: () => paymentData?.LoanAmount > paymentData?.EligibleAmount, // Check if LoanAmount is > EligibleAmount
      then: (schema) =>
        schema.required(
          "Equity Contribution is required if Loan Amount is greater than Eligible Amount"
        ),
      otherwise: (schema) => schema.notRequired(),
    }),
    Tenor: Yup.string().required("Tenor is required"),
  });

  useEffect(() => {
    setIsChecked(paymentData?.Meta?.Items?.IsNew);
  }, []);

  function validateEquity(value: any) {
    const check = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?~]/.test(value);

    let error;
    if (value > paymentData?.Amount) {
      setHideEquity(true);
      error = "Amount must not exceed  loan amount!";
    }
    if (value < paymentData?.MinimumEquity) {
      setHideEquity(true);
      error = "input an amount equal to or above the minimum equity amount!";
    }
    if (check) {
      setHideEquity(true);
      error = "Only numbers are allowed";
    } else {
      setHideEquity(false);
    }

    return error;
  }

  function formatCurrency(amount: number) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "NGN",
    }).format(amount);
  }

  const formattedAmount = formatCurrency(amount);

  const handleKeyDown = (event: any) => {
    const invalidChars = ["-", "e", "+", "E"];
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    if (paymentCode) {
      setLoading(true);
      dispatch(getUserPaymentDetail({ paymentCode: paymentCode }))
        .unwrap()
        .then(() => {
          setLoading(false);
        })
        .catch((err: any) => {
          toast.error(err);
          setLoading(false);
        });
    }
  }, [dispatch]);

  const total = paymentData?.Meta?.Items.reduce(
    (accumulator: number, item: any) => {
      const price = parseFloat(item.Amount);
      return isNaN(price) ? accumulator : accumulator + price;
    },
    0
  );

  return (
    <div>
      <Modal
        title="Basic Modal"
        destroyOnClose={true}
        centered
        width={"80%"}
        open={props.isModalOpen}
        onOk={props.handleOk}
        // onCancel={props.handleCancel}
        className={Styles.customModal}
        modalRender={modal => (
          <div style={{ borderRadius: '0px' }}>
            {modal}
          </div>
        )}
      >
        <div
          className={Styles.modalContentVerification}
          style={{ paddingTop: "0em" }}
        >
          <div className={Styles.topHeader}>
            <div>
              <img
                onClick={props.goBack}
                src={Back}
                className={Styles.backIcon}
                alt="back"
              />
            </div>
            {/* <div>
              <img
                onClick={props.handleCancel}
                src={Cancel}
                className={Styles.cancelIcon}
                alt="horse"
              />
            </div> */}
          </div>

          {loading ? (
            <LoadingCard />
          ) : (
            <div className={Styles.row}>
              <div className={Styles.half} style={{ marginTop: "0em" }}>
                <div className={Styles.userName}></div>
                <div className={Styles.subDetail}>
                  Hello {paymentData?.Name}
                </div>
                <div className={Styles.subDetails}>Your order by Konga</div>
                <div className={Styles.merchantBox}>
                  {paymentData?.Meta?.Items ? (
                    <>
                      <div className={Styles.box}>
                        <div className={Styles.items}>
                          <span>No.</span>
                          <span>Item(s)</span>
                          <span>Quantity</span>
                          <span>Price</span>
                        </div>
                        {paymentData?.Meta?.Items.map(
                          (item: any, index: any) => (
                            <div className={Styles.item} key={index}>
                              {" "}
                              <span>{index + 1}</span>
                              <span>{item?.Name}</span>
                              <span>{item?.Quantity}</span>
                              <span>{formatAmount(item?.Amount)}</span>
                            </div>
                          )
                        )}

                        <div className={Styles.item}>
                          <span></span>
                          <span></span>
                          <span style={{ fontWeight: "700", fontSize: "14px" }}>
                            Total
                          </span>
                          <span style={{ fontWeight: "700", fontSize: "14px" }}>
                            {formatAmount(paymentData?.Amount)}
                          </span>
                        </div>
                      </div>
                    </>
                  ) : (
                    <span>No items found</span>
                  )}
                  {/* })} */}
                </div>
              </div>

              <div className={Styles.halfTwo} style={{ padding: "0em" }}>
                <div className={Styles.loanBlueBox}>
                  <div className={Styles.rowContent}>
                    <div
                      style={{ color: "#32496F" }}
                      className={Styles.descTwo}
                    >
                      Eligible amount
                    </div>
                    <div
                      style={{ fontWeight: "bolder", color: "#003E93" }}
                      className={Styles.descTwo}
                    >
                      {formatAmount(paymentData?.EligibleAmount)}
                    </div>
                  </div>
                  <div className={Styles.rowContent}>
                    <div
                      style={{ color: "#32496F" }}
                      className={Styles.descTwo}
                    >
                      Loan amount
                    </div>
                    <div
                      style={{ fontWeight: "bolder", color: "#003E93" }}
                      className={Styles.descTwo}
                    >
                      {formatAmount(loanAmount)}
                    </div>
                  </div>

                  <div className={Styles.rowContent}>
                    <div
                      style={{ color: "#32496F" }}
                      className={Styles.descTwo}
                    >
                      Minimum Equity Contribution
                    </div>
                    <div
                      style={{ fontWeight: "bolder", color: "#003E93" }}
                      className={Styles.descTwo}
                    >
                      {formatAmount(MinimumEquity)}
                    </div>
                  </div>
                </div>

                <Formik
                  enableReinitialize
                  initialValues={{
                    EquityContribution:
                      paymentData?.EquityContribution > 0
                        ? paymentData?.EquityContribution
                        : "",
                    Tenor: paymentData?.Tenor > 0 ? paymentData?.Tenor : "",
                  }}
                  validationSchema={VehicleSchema}
                  onSubmit={(values) => {
                    props.openConfirmation(values);
                  }}
                >
                  {(formik) => (
                    <Form autoComplete="off">
                      <div className={Styles.top}>
                        <div className={""}>
                          {/* Styles.rowSelect */}
                          <div className={""}>
                            {/* Styles.inputHalfSelect */}
                            <div
                              className={Styles.inputTitle}
                              style={{ marginBottom: "0px" }}
                            >
                              Equity Contribution
                              <span style={{ display: paymentData?.LoanAmount > paymentData?.EligibleAmount ? '' : 'none' }} className={Styles.asteriks}>*</span>
                            </div>

                            <div style={{ position: "relative", width: "100%" }}>
                              <span
                                style={{
                                  position: "absolute",
                                  left: "10px",
                                  fontSize: "1rem",
                                  fontWeight: "bold",
                                  color: "gray",
                                  top: "54%", // Adjust for better centering
                                  transform: "translateY(-50%)",
                                  backgroundColor: "white", // Prevents overlap by input
                                  padding: "0 4px", // Adds spacing to avoid text cutting
                                  zIndex: 2, // Ensures it stays above input
                                }}
                              >
                                ₦
                              </span>
                              <Field
                                validate={validateEquity}
                                component={InputField}
                                name="EquityContribution"
                                type="number"
                                placeholder="Enter amount"
                                value={formattedAmount}
                                onKeyDown={handleKeyDown}
                                onChange={(event: any) =>
                                  props.onEquityInputChange(event, formik)
                                }
                                autoComplete="off"
                                style={{
                                  paddingLeft: "30px", // Ensures text doesn't overlap ₦
                                  width: "100%",
                                  height: "40px",
                                  position: "relative", // Allows Naira symbol stacking
                                  zIndex: 1, // Ensures input is behind ₦
                                  backgroundColor: "transparent", // Avoids background overlap
                                }}
                              />
                            </div>
                            <ErrorMessage name="EquityContribution">
                              {(msg: string) => <HelperText>{msg}</HelperText>}
                            </ErrorMessage>
                          </div>

                          {!formik.errors.EquityContribution && (
                            <div className={""}>
                              <div
                                className={Styles.inputTitle}
                                style={{ marginBottom: "0px" }}
                              >
                                Please select a tenor
                                <span className={Styles.asteriks}>*</span>
                              </div>
                              <Field
                                onSelect={props.onSelectChange}
                                name="Tenor"
                                component={SelectField}
                                autoComplete="off"
                              >
                                {Tenor.map((prod: any, index: any) => (
                                  <Option
                                    className={Styles.selectOption}
                                    key={index}
                                    value={prod.code}
                                  >
                                    {prod.name}
                                  </Option>
                                ))}
                              </Field>
                              <ErrorMessage name="Tenor">
                                {(msg: string) => (
                                  <HelperText>{msg}</HelperText>
                                )}
                              </ErrorMessage>
                            </div>
                          )}
                        </div>
                      </div>

                      {loadingApi && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingTop: "1em",
                          }}
                        >
                          <Spin
                            indicator={
                              <LoadingOutlined
                                style={{ fontSize: 20, color: "black" }}
                                spin
                              />
                            }
                          />
                        </div>
                      )}

                      <div>
                        {repaymentResponseData && (
                          <div>
                            <div className={Styles.rowContents}>
                              <div
                                className={Styles.descTwos}
                                style={{
                                  width: "60%",
                                  display: "block",
                                  lineHeight: "1.5em",
                                }}
                              >
                                Total Repayment Amount
                              </div>
                              <div
                                style={{
                                  fontWeight: "bolder",
                                }}
                                className={Styles.descTwos}
                              >
                                {formatAmount(
                                  repaymentResponseData?.TotalRepayment
                                )}
                              </div>
                            </div>

                            <div className={Styles.rowContents}>
                              <div className={Styles.descTwos}>
                                Monthly Repayment Amount
                              </div>
                              <div
                                style={{
                                  fontWeight: "bolder",
                                }}
                                className={Styles.descTwos}
                              >
                                {formatAmount(
                                  repaymentResponseData?.MonthlyRepayment
                                )}
                              </div>
                            </div>

                            <div className={Styles.top}>
                              <Button
                                // variant={
                                //   !(formik.isValid && formik.dirty) && !loading
                                //     ? "disabled"
                                //     : "primary"
                                // }
                                variant="primary"
                                type="submit"
                                label="CONTINUE"
                                disabled={props.loadingApi}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          )}
        </div>
        <div></div>
      </Modal>
    </div>
  );
};

export default PayWithQuickbuckDetailsModal;
